import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dcf03b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headert" }
const _hoisted_2 = {
  style: {"padding-bottom":"0"},
  class: "navbar navbar-1 navbar-expand-lg navbar-light py-0"
}
const _hoisted_3 = { class: "container-fluid child-div" }
const _hoisted_4 = { href: "https://em.techandover.com/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-4dcf03b6><span class=\"navbar-toggler-icon\" data-v-4dcf03b6></span></button><div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\" data-v-4dcf03b6><ul class=\"navbar-nav ms-auto mb-2 mb-lg-0\" data-v-4dcf03b6><li class=\"nav-item\" data-v-4dcf03b6><a class=\"nav-link nav-linkks link-a px-lg-3\" aria-current=\"page\" href=\"https://em.techandover.com/\" data-v-4dcf03b6>HOME</a></li><li class=\"nav-item\" data-v-4dcf03b6><a class=\"nav-link nav-linkks px-lg-3 link-b\" href=\"https://em.techandover.com/contact/\" data-v-4dcf03b6>CONTACT US</a></li><li class=\"nav-item\" data-v-4dcf03b6><a class=\"nav-link nav-linkks px-lg-3 link-c\" href=\"https://emerture.netlify.app/sign-in\" data-v-4dcf03b6>LOGIN/REGISTER</a></li></ul></div>", 2)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {"padding":"0px !important","margin-top":"0px"},
  class: "text-white"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  style: {"font-size":"36px","line-height":"1","letter-spacing":"0.04em","font-weight":"700"},
  class: "text-white text-center mt-8rem"
}, null, -1))
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              class: "nav-logoo",
              src: require('@/assets/img/emerture.png'),
              alt: "logo"
            }, null, 8, _hoisted_5)
          ]),
          _hoisted_6
        ])
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _createElementVNode("div", {
      class: "w-md-75 bg-white rounded shadow-sm p-10 p-lg-15 mx-auto",
      innerHTML: _ctx.inner
    }, null, 8, _hoisted_10)
  ], 64))
}